import { Text, Multimedia } from '@clockout-dev/design-elements';
import { SupportTicketConstants } from '../support.enums';
import { formatMessageTime } from '../ticket.utils';
import styles from '../styles/ticket-thread.module.scss';

/**
 * @param {Object} props
 * @param {{ id: string, body: string, author: { name: string, role: string }, createdAt: string, multimedia?: Array<{ id: string, url: string, name: string, type: string }> }} props.message
 * @param {number} [props.animationIndex]
 */
function TicketMessage({ message, animationIndex = 0 }) {
    const isAdmin = message.author?.role === SupportTicketConstants.AUTHOR_ROLE.ADMIN;
    const authorName = message.author?.name || '—';
    const roleLabel = isAdmin ? 'Admin' : 'Clockout';
    const formattedTime = formatMessageTime(message.createdAt);
    const cappedIndex = Math.min(animationIndex, 8);
    const messageClass = isAdmin ? styles.messageAdmin : '';
    const attachments = message.multimedia ?? [];


    return (
        <article
            id={`message-${message.id}`}
            className={`${styles.message} ${messageClass}`}
            style={{ animationDelay: `${cappedIndex * 0.04}s` }}
        >
            <div className={styles.messageContent}>
                <div className={styles.messageMeta}>
                    <Text as="span" className={styles.authorName}>
                        {authorName}
                    </Text>
                    <Text as="span" className={styles.roleLabel}>
                        {roleLabel}
                    </Text>
                    <Text as="span" className={styles.time}>
                        {formattedTime}
                    </Text>
                </div>
                {message.body ? (
                    <Text as="p" className={styles.body}>
                        {message.body}
                    </Text>
                ) : null}
                {attachments.length > 0 && (
                    <div className={styles.attachments}>
                        {attachments.map((att, i) => {
                            const isValidUrl = /^https?:\/\//i.test(att.url);
                            const url = isValidUrl ? att.url : `https://${att.url}`;
                            return (
                                <Multimedia
                                    key={att.id ?? `${att.name}-${i}`}
                                    src={url}
                                    name={att.name}
                                    type={att.type}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </article>
    );
}

export default TicketMessage;
